import { Reducer } from 'redux'
import { TabValues, ActionTypes, TAB_KEY, Filters, CARD_DETAILS_ACTIONS } from './types'
import { SORT_TYPE } from '~/biz/store/cards/types'

const initialState: State = {
  tabKey: TAB_KEY.TRANSACTIONS,
  tabValues: {
    [TAB_KEY.TRANSACTIONS]: {
      isTxnLoading: false,
      transactions: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
    [TAB_KEY.STATUS_LOGS]: {
      isTxnLoading: false,
      statusLogs: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
    [TAB_KEY.CUSTOMER_CARDS]: {
      isTxnLoading: false,
      cards: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
  },
}

type State = {
  tabKey: TAB_KEY
  tabValues: TabValues
}

export const cardDetails: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case CARD_DETAILS_ACTIONS.SET_FILTERS: {
      const { tabKey } = state

      if (tabKey === null) throw new Error('tabKey cannot be null!')

      const { filters } = action

      const newTabFilters: Filters = {
        ...state.tabValues[tabKey].filters,
      }

      Object.keys(filters).forEach((key: string) => {
        const values = filters[key]
        newTabFilters[key] = values
      })

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [tabKey]: {
            ...state.tabValues[tabKey],
            filters: {
              ...state.tabValues[tabKey].filters,
              ...newTabFilters,
            },
          },
        },
      } as State
    }

    case CARD_DETAILS_ACTIONS.SET_PAGE: {
      const { tabKey } = state

      if (tabKey === null) throw new Error('tabKey cannot be null!')

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [tabKey]: {
            ...state.tabValues[tabKey],
            page: action.page,
          },
        },
      }
    }

    case CARD_DETAILS_ACTIONS.SET_TOTAL_COUNT: {
      const { tabKey } = state

      if (tabKey === null) throw new Error('tabKey cannot be null!')

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [tabKey]: {
            ...state.tabValues[tabKey],
            totalCount: action.totalCount,
          },
        },
      }
    }

    case CARD_DETAILS_ACTIONS.SWITCH_TAB: {
      return {
        ...state,
        tabKey: action.tabKey,
      }
    }

    case CARD_DETAILS_ACTIONS.SET_IS_TXN_LOADING: {
      const { tabKey } = state

      if (tabKey === null) throw new Error('tabKey cannot be null!')

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [tabKey]: {
            ...state.tabValues[tabKey],
            isTxnLoading: action.isTxnLoading,
          },
        },
      }
    }

    case CARD_DETAILS_ACTIONS.SET_TRANSACTIONS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TAB_KEY.TRANSACTIONS]: {
            ...state.tabValues[TAB_KEY.TRANSACTIONS],
            transactions: action.transactions,
          },
        },
      }
    }

    case CARD_DETAILS_ACTIONS.SET_STATUS_LOGS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TAB_KEY.STATUS_LOGS]: {
            ...state.tabValues[TAB_KEY.STATUS_LOGS],
            statusLogs: action.statusLogs,
          },
        },
      }
    }

    case CARD_DETAILS_ACTIONS.SET_CUSTOMER_CARDS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TAB_KEY.CUSTOMER_CARDS]: {
            ...state.tabValues[TAB_KEY.CUSTOMER_CARDS],
            cards: action.cards,
          },
        },
      }
    }

    default:
      return state
  }
}
